import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ContentService } from 'src/app/services/content/content.service';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { CenterSectionComponent, TextButtonComponent } from 'src/app/shared/components';
import { ContentSection } from '../../../shared/layout/content-section';
import { SanitizeHtmlPipe } from '../../../shared/pipes/sanitize-html.pipe';

@Component({
  selector: 'app-kage-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CenterSectionComponent, SanitizeHtmlPipe, TextButtonComponent],
})
export class CookiePolicyComponent extends ContentSection implements OnInit {
  private dialogService = inject(DialogService);

  title: string;
  body: string;
  changeConsentLabel: string;

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, 'cookies', { meta: true });
  }

  ngOnInit() {
    this.title = this.content.get('titleText');
    this.body = this.content.get('descriptionText');

    this.body = this.contentService.addImageSource(this.body);
    this.body = this.contentService.addLinkSource(this.body);

    this.changeConsentLabel = this.content.get('changeConsentLabelText');
  }

  changeConsent() {
    this.dialogService.openCookieConsentDialog(true);
  }
}
